import styled from 'styled-components';

const GuideStyle = styled.div`
    --fontColor: white;
    /* height: 100vh;
    width: 100%; */
    // background-image: url(${props => props.image}) ;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100vh;
    width: 100%;

    .flex_container_row{
        height: 100vh;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex_start;
        align-content: center;
    }

    .flex_container_title{
        position:relative;
        background: #E55145; 
        width: 100%; 
        height: 5vh; 
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.5);

        .text{
            color: #FFFFFF; 
            font-weight: bold; 
            margin: 0 0 0 15px;
            font-size: 24px;
        }
    }

    .flex_container{
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-content: center;
 
        /* border : 2px solid red; */
    }

    .flex_container .video-iframe{
        box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
    }

    .tutorialList{
        width: 10vw;
        height: 80vh;
        overflow-y: auto;
        background: #f3f3f3;
        padding: 10px;
        display: flex;
        justify-content: flex-start;

        .videoList{
            width: 100%;
            margin: 1px 0 1px 0;
            padding: 10px 0 5px 0;
            cursor: pointer;
            display: flex;
            align-content: center;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            .videoListLabel{
                margin: 10px 0; 
                font-weight: bold;
                text-align: center;
                font-size: 16px;
            }
        }
        .videoList.selected{
            border: 2px solid #e1081a;
            border-radius: 25px;
        }

        .videoList:hover{
            background: rgba(199, 55, 48, 0.87);
            border-radius: 25px;
            color: #FFFFFF;
        }
    }

    .tutorialContent{
        width: 80vw;
        height: 95vh;
        // justify-content: flex-start;
    }

    .selectedTutorialLabel{
        color: #121212;
        // margin: 0 15px 15px 15px;
        // padding: 0 15px 0 15px;
        width: 100%;
        font-weight: bold;
        font-size: 30px;
    }

    .flex_column{
        /* height: 100vh;
        width: 100%; */
        height : 550px;
        width : 400px;
        display: flex;
        flex-direction: column;
         justify-content: center;
        align-items: center;
        align-content: center;

        /* border : 2px solid black; */
        /* background : rgba(0,0,0,0.9); */
        background : rgba(3,20,40,0.9);
        border-radius: 10px;
    }

    .flex_item{
        padding : 5px;
    }

    .logo_item{
        height : 80px;
        width: 80px;
        border-radius: 0px;
    }
    `
export default GuideStyle;
